import { useState } from 'react';
import { useAuth } from '../lib/auth';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null);
    setBekliyor(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Giriş başarısız');
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <div className="ccd">
      <div className="ccd-authwrap">
        <form className="ccd-card ccd-authcard ccd-stack" onSubmit={gonder}>
          <div>
            <div className="ccd-eyebrow">Art Mozaik &amp; Seramik</div>
            <h1 className="ccd-title">Operasyon Paneli</h1>
          </div>

          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="k">Kullanıcı adı</label>
            <input
              id="k" className="ccd-input" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} autoFocus
              value={username} onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="p">Parola</label>
            <input
              id="p" className="ccd-input" type="password" autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {hata && (
            <div className="ccd-banner ccd-banner-danger">
              <span className="ccd-banner-icon" aria-hidden="true">!</span>
              <span>{hata}</span>
            </div>
          )}

          <button className="ccd-btn ccd-btn-primary ccd-btn-block" disabled={bekliyor}>
            {bekliyor ? 'Giriş yapılıyor…' : 'Giriş'}
          </button>

          <p className="ccd-meta">
            Parolanı bilmiyorsan Buğra ya da Mehmetcan sıfırlayabilir.
          </p>
        </form>
      </div>
    </div>
  );
}
